<template>
  <div class="row">
    <div class="col-sm-6">
      <fg-input
        type="text"
        :value="value"
        @input="$emit('input', $event)"
        :placeholder="placeholder"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    placeholder: {
      default: 'Suchen...'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
